import React, { PureComponent } from 'react';
import getExcelHelper from '../../../../Common/Helpers/GetExcelHelper';

class SectorSuperior extends PureComponent {
    constructor(props) {
        super(props);
    }

    ExportarExcel() {
        let arrayAjusteCargo =  this.props.ajusteCargo;
        arrayAjusteCargo.map((x) => delete x.Id);

        getExcelHelper.ExportarExcel('Ajustes_Cargos.csv', arrayAjusteCargo);
    }

    mostrarModalCambiarEstado(mostrarModal, totalMovimientos) {
        this.props.mostrarModalCambiarEstado(mostrarModal, totalMovimientos);
    }

    render() {
        const { ajusteCargoTotal, totalChecks } = this.props;

        return (
            <div className={"confirmadorAjusteCargoTable"}>
                <div className={"confirmadorAjusteCargoDivLineaDivisoria"}></div>

                <div className={"confirmadorAjusteCargoDivCantReg"}>
                    <div>
                        <label>Cantidad de Registros</label>
                    </div>
                    <div>
                        <div>{ajusteCargoTotal}</div>
                    </div>
                </div>

                <div className={"confirmadorAjusteCargoDivCambiarEstado"}>
                    <button className={"btn btn-cta confirmadorAjusteCargoBtnCambiarEstado"} onClick={() => this.mostrarModalCambiarEstado(true, totalChecks)}>Cambiar estado</button>
                </div>
                
                <div className={"confirmadorAjusteCargoDivBtnExcel confirmadorAjusteCargoBtnExcel"} onClick={() => this.ExportarExcel()}></div>
            </div>
        )
    }
}

export default SectorSuperior;